import { createGlobalStyle } from "styled-components";
import SFMonoRegular from "../assets/fonts/SFMono-Regular.ttf";

const Typography = createGlobalStyle`
  @font-face {
    font-family: 'SFMono Regular';
    src: url(${SFMonoRegular});
    font-style: normal;
  }

 
  h1{
    font-family: 'Inter', sans-serif;
    font-weight: 800;
  }

  h2{
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    
  }

  p,span,li,a{
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 1.6rem;


  }




`;

export default Typography;
